import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { LoginPage } from '../modules/auth/ui/pages/LoginPage';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    if (getCurrentSession()) {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: LoginPage,
});
